import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import PropertyData from "./property-list.json";
import "swiper/css";
import "swiper/css/pagination";
import { motion, AnimatePresence } from "framer-motion";

// icon
import Icon from "@mdi/react";

import { mdiMapMarkerRadiusOutline, mdiBedOutline, mdiBathtubOutline, mdiLan, mdiCarSide, mdiCountertop, mdiDumbbell, mdiWifi, mdiShieldLockOutline } from "@mdi/js";

// Map of icon paths for property facilities

const iconPaths = { mdiBedOutline, mdiBathtubOutline, mdiLan, mdiCarSide, mdiCountertop, mdiDumbbell, mdiWifi, mdiShieldLockOutline, };

export default function PropertyBookModal({
  showProperty,
  handleCloseProperty,
}) {
  // State to manage the property data
  const [PropertyDataList] = useState(PropertyData);
  const [previewImage, setPreviewImage] = useState(null);
  const [isImageClicked, setIsImageClicked] = useState(false);
  const swiperRef = useRef(null);

  // Function to handle image click
  const handleImageClick = (image) => {
    setPreviewImage(image);
    setIsImageClicked(!isImageClicked); // Stop autoplay
    if (swiperRef.current?.autoplay) {
      swiperRef.current.autoplay.stop();
    }
  };

  // Resume autoplay when preview image modal is closed
  useEffect(() => {
    if (
      !previewImage &&
      swiperRef.current?.autoplay &&
      !swiperRef.current.autoplay.running
    ) {
      swiperRef.current.autoplay.start();
      setIsImageClicked(false);
    }
  }, [previewImage]);

  return (
    <>
      {/* Property Booking Modal */}
      <Modal show={showProperty} onHide={handleCloseProperty} size="lg" centered>
        {/* Modal Header */}
        <Modal.Header className="p-0" closeButton />
        {/* Modal Body */}
        <Modal.Body>
          {/* Property Slider */}
          {/* 
           */}
          {/* Property Title and Rating */}
          {/* <motion.div
            className="d-flex justify-content-between align-items-center mb-3"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h6
              className="text-secondary fs-15 text-uppercase my-0"
              style={{ letterSpacing: "1px" }}
            >
              Row House
            </h6>
            <div className="d-flex text-warning gap-2 fs-15">
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
            </div>
          </motion.div> */}
          {/* Rent Price and Book Now Button */}
          {/* <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <p className="mb-1 text-secondary fs-6">Rent Price</p>
              <h2 className="mb-0">
                <span className="text-primary fw-bold fs-3">$1,600</span>
                <span className="fs-15 text-white opacity-75 ps-1">/Month</span>
              </h2>
            </div>
            <button type="button" className="btn btn-primary btn-hover rounded-3 py-2 px-4 fw-bold">Book Now</button>
          </div> */}
          {/* Property Location */}
          <h3 className="mt-3 fs-2">The Most Luxurious House</h3>
          <div className="text-white opacity-80 fs-6">
            <Icon path={mdiMapMarkerRadiusOutline} className="icon-size-20 me-2" />
             North BB Creek Townhomes,Carlos G. Parker Boulevard, Taylor, Williamson Country,TX
          </div>
          <hr className="my-4 opacity-25" />
          {/* House Facilities */}
          <h6 className="fs-5 mb-4 text-decoration-underline">House Facilities</h6>
          {/* Map through the property facilities and create a row of icons */}
          <Row className="g-3">
            {PropertyDataList.PropertyFaciliti1.map((data, i) => (
              <Col sm={6} lg={3} key={i}>
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-sm bg-soft-primary text-primary rounded-circle me-3">
                    <Icon path={iconPaths[data.iconName]} className="icon-size-20" />
                  </div>
                  <h5 className="fs-6 mb-0">{data.facilitiName}</h5>
                </div>
              </Col>
            ))}
            
            
          </Row>
         <hr className="my-4 opacity-25" />
          <h5 className="fs-5 mb-3">Other Options</h5>
          <ul className="mb-0 ps-4">
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Add Garage Door with Opener:</b> for around $3000</li>
           <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">To Split 2ND Bedroom Into 3 Bedrooms</b> for an additional $10000</li>
           <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">To convert 3Rd Bedroom </b> Into Media room</li>
            </ul>
          
          {/* Key Features */}
          <hr className="my-4 opacity-25" />
          <h5 className="fs-5 mb-3">Additional Features</h5>
          <ul className="mb-0 ps-4">
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Master Suite is spacious for a townhome design with double sink. and standing shower</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Long pantry</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Spacious powder room</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Open kitchen design</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Spacious counter tops with maximum cabinetry space</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Two compact cars fit in carport/garage(2-3 BedroomHouse)</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Master Suite is spacious for a townhome design with double sink and standing shower</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">5 Bedroom unit comes in 3 floors.</b>1st floor with optional neighborhood commercial space subject to approvals</li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Interior upgrades are buyers responsibility</b></li>
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">The cost of the design and construction extra based on sq.ft</b></li>
        </ul>

          <h5 className="fs-5 mb-3">Payment Options</h5>
          <ul className="mb-0 ps-4">
            <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">12.5% of unit price at the time of booking/contract</b></li>
           <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">12.5% of unit price after completion of horizontal work and before start of vertical development</b></li>
           <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">Collected amount can be used towards loan down payment</b></li>
           <li className="mb-2 text-white text-opacity-85 fs-6"><b className="fw-semibold text-white">All payments are processed through Title company</b></li>
            </ul>
          


          {/* Preview Image Modal */}
          <AnimatePresence>
            {previewImage && (
              <motion.div className="custom-lightbox d-flex justify-content-center align-items-center"
                onClick={() => setPreviewImage(null)}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(42, 50, 60, 0.6)",
                  zIndex: 1055,
                  cursor: "zoom-out",
                  backdropFilter: "blur(10px)",
                }}
              >
                <motion.img  className="img-fluid rounded-4 shadow"
                  src={previewImage}
                  alt="Preview"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.8, opacity: 0 }}
                  transition={{ duration: 0.4, ease: "easeOut" }}
                  style={{
                    maxWidth: "40%",
                    maxHeight: "40vh",
                    objectFit: "contain",
                  }}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </Modal.Body>
      </Modal>
    </>
  );
}
